export * from "./vendas-detalhado.component";
